<template>
  <div>
    <!-- 货架设置 -->
    <el-dialog :title="isAdd ? $t('message.batchCreateSystemShelf') : $t('message.shelfSetting')"
      :close-on-click-modal="false" :close-on-press-escape="!creating" :show-close="!creating"
      :visible.sync="dialogVisible" width="520px" center
      v-loading="creating" :element-loading-text="createLoadingText" element-loading-spinner="el-icon-loading">
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <!-- 创建货架个数：批量创建时循环调用创建接口 -->
          <el-form-item v-if="isAdd" :label="$t('message.createShelfCount') + '：'" prop="create_count">
            <el-input v-model="ruleForm.create_count" :placeholder="$t('message.createShelfCount')"
              @input="sanitizeCreateCount" @blur="onCreateCountBlur"></el-input>
          </el-form-item>
          <!-- 属性 -->
          <el-form-item :label="$t('message.property') + '：'" prop="range_type">
            <el-radio v-model="ruleForm.range_type" :label="2">{{ $t("message.publicShelf") }}</el-radio>
            <el-radio v-model="ruleForm.range_type" :label="1">{{ $t("message.personalShelf") }}</el-radio>
          </el-form-item>
          <!-- 使用范围 -->
          <el-form-item :label="$t('message.scopeOfUse') + '：'"
            :prop="ruleForm.range_type == 1 ? 'admin_id' : 'org_id'">
            <el-select v-model="ruleForm.admin_id" :placeholder="$t('message.specificPersonnel')" filterable
              v-if="ruleForm.range_type == 1" clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
            <cascader @setUserList="setUserList" :org_id="ruleForm.org_id"
              v-else-if="dialogVisible && ruleForm.range_type == 2" />
          </el-form-item>
          <!-- 所属区域 -->
          <el-form-item :label="$t('message.owningRegion') + '：'" prop="area_number">
            <el-select v-model="ruleForm.area_number" :placeholder="$t('message.owningRegion')" filterable clearable>
              <el-option v-for="item in areaList" :key="item.id" :label="item.area_number" :value="item.area_number">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 货架类别 -->
          <el-form-item :label="$t('message.categoryOfShelves') + '：'" prop="shelf_type">
            <el-select v-model="ruleForm.shelf_type" :placeholder="$t('message.categoryOfShelves')" filterable
              clearable>
              <el-option v-for="item in typeOptions" :key="item.id" :label="item.type" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
         
          <!-- 货架尺寸(米) -->
          <el-form-item :label="$t('message.shelfSizeMeters') + '：'" prop="c">
            <el-col :span="7">
              <el-form-item prop="c">
                <el-input v-model="ruleForm.c" :placeholder="$t('message.length')"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">
              <div style="text-align: center">x</div>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="k">
                <el-input v-model="ruleForm.k" :placeholder="$t('message.width')"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">
              <div style="text-align: center">x</div>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="g">
                <el-input v-model="ruleForm.g" :placeholder="$t('message.height')"
                  onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- 货架备注 -->
          <el-form-item :label="$t('message.remarksOnShelves') + '：'" prop="name">
            <el-input v-model="ruleForm.remark" :placeholder="$t('message.remarksOnShelves')"
              type="textarea"></el-input>
          </el-form-item>
           <!-- 货架层数：默认1，1-10的正整数；下方按层填写库位数 -->
           <el-form-item :label="$t('message.shelfLayerNumber') + '：'" prop="shelf_floor">
            <el-input v-model="ruleForm.shelf_floor" :placeholder="$t('message.shelfLayerNumber')"
              @input="sanitizeShelfFloor" @blur="onShelfFloorBlur"></el-input>
          </el-form-item>
          <div class="floor-grids">
            <div class="floor-grid-row" v-for="item in floorGrids" :key="item.floor">
              <span class="floor-label">{{ item.floor }}层：</span>
              <el-input v-model="item.num" :placeholder="$t('message.numberOfLibraryPositions')"
                @input="sanitizeGridNum(item)" @blur="onGridNumBlur(item)"></el-input>
            </div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="creating" @click="dialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <el-button type="primary" v-if="isAdd" :loading="creating" @click="shelfStore">{{ $t("message.save") }}</el-button>
        <el-button type="primary" v-else @click="shelfUpdate">{{ $t("message.save") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      isAdd: true,
      creating: false,
      createCurrent: 0,
      createTotal: 0,
      ruleForm: {},
      floorGrids: [],
      originGrids: {},
      areaList: [],
      typeOptions: [],
      userList: [],
      rules: {
        area_number: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        range_type: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        org_id: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        admin_id: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        shelf_floor: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        c: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        k: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        g: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        shelf_type: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
        create_count: [
          { required: true, message: this.$t("message.TheRequired"), trigger: "blur" },
        ],
      },
    }
  },
  computed: {
    createLoadingText() {
      return this.$t('message.creating') + ' ' + this.createCurrent + ' / ' + this.createTotal
    },
  },
  created() {
    this.getAreaList()
    this.shelfTypes()
    this.$api.roleApi.accountNumberList({ pageSize: 9999999 }).then((res) => {
      res.data.data.forEach((item) => {
        if (item.role != false) {
          item.realname = item.realname + "_" + item.role[0].name
        }
      })
      this.userList = res.data.data
    })
  },
  methods: {
    open(item) {
      this.creating = false
      this.createCurrent = 0
      this.createTotal = 0
      this.floorGrids = []
      this.originGrids = {}
      if (item) {
        this.isAdd = false
        this.ruleForm = JSON.parse(JSON.stringify(item))
        this.originGrids = this.parseOriginGrids(item)
        const floor = Number(this.ruleForm.shelf_floor)
        this.ruleForm.shelf_floor = floor >= 1 ? Math.min(floor, 10) : 1
      } else {
        this.isAdd = true
        this.ruleForm = {
          area_number: "",
          range_type: 2,
          org_id: "",
          no: "",
          admin_id: "",
          shelf_floor: 1,
          c: "",
          k: "",
          g: "",
          remark: "",
          shelf_type: "",
          create_count: 1,
        }
      }
      this.syncFloorGrids()
      this.dialogVisible = true
    },
    parseOriginGrids(item) {
      const origin = {}
      const list = item && item.floor_grids
      if (!Array.isArray(list)) return origin
      list.forEach((row) => {
        const floor = Number(row.floor)
        if (floor) origin[floor] = Number(row.grid_count || 0)
      })
      return origin
    },
    sanitizeShelfFloor(val) {
      let digits = String(val == null ? '' : val).replace(/[^\d]/g, '').replace(/^0+/, '')
      if (digits === '') {
        this.ruleForm.shelf_floor = ''
        this.floorGrids = []
        return
      }
      let n = parseInt(digits, 10)
      if (n > 10) n = 10
      this.ruleForm.shelf_floor = n
      this.syncFloorGrids()
    },
    onShelfFloorBlur() {
      if (!this.ruleForm.shelf_floor) {
        this.ruleForm.shelf_floor = 1
        this.syncFloorGrids()
      }
    },
    syncFloorGrids() {
      const count = Number(this.ruleForm.shelf_floor) || 0
      const prev = {}
      this.floorGrids.forEach((item) => {
        prev[item.floor] = item
      })
      const next = []
      for (let floor = count; floor >= 1; floor--) {
        const old = prev[floor]
        const min = Number(this.originGrids[floor] || 0)
        const num = old ? old.num : min
        next.push({
          floor,
          num: num === '' ? '' : Number(num || 0),
        })
      }
      this.floorGrids = next
    },
    // 修改货架时允许重新输入每层库位数，输入过程仅保留数字，不再锁定原始数量。
    sanitizeGridNum(item) {
      const digits = String(item.num == null ? '' : item.num).replace(/[^\d]/g, '')
      item.num = digits === '' ? '' : parseInt(digits, 10)
    },
    onGridNumBlur(item) {
      if (item.num === '') item.num = 0
    },
    sanitizeCreateCount(val) {
      const digits = String(val == null ? '' : val).replace(/[^\d]/g, '').replace(/^0+/, '')
      this.ruleForm.create_count = digits
    },
    onCreateCountBlur() {
      if (!this.ruleForm.create_count) this.ruleForm.create_count = 1
    },
    buildPayload() {
      const data = { ...this.ruleForm }
      delete data.shelf_grid
      delete data.create_count
      this.floorGrids.forEach((item) => {
        data['shelf_grid[' + item.floor + ']'] = item.num
      })
      return data
    },
    getAreaList() {
      this.$api.warehouseApi.areaList({ page: 1, pageSize: 999999 }).then((res) => {
        this.areaList = res.data.data
      })
    },
    shelfTypes() {
      this.$api.warehouseApi.shelfTypes({}).then((res) => {
        this.typeOptions = res.data
      })
    },
    setUserList(data) {
      this.ruleForm.org_id = data.id
    },
    shelfStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        const count = Number(this.ruleForm.create_count)
        if (!count) return
        this.createSequentially(count)
      })
    },
    async createSequentially(count) {
      const payload = this.buildPayload()
      this.creating = true
      this.createCurrent = 0
      this.createTotal = count
      let lastRes = null
      let failed = false
      let successCount = 0
      for (let i = 0; i < count; i++) {
        this.createCurrent = i + 1
        try {
          lastRes = await this.$api.warehouseApi.shelfStore(payload, {
            isLoading: true,
            resolveError: true,
          })
          if (lastRes && lastRes.code != 0 && lastRes.code != 10003 && lastRes.code != 10004) {
            failed = true
            break
          }
          successCount++
        } catch (e) {
          failed = true
          break
        }
      }
      this.creating = false
      if (!failed) {
        this.$message.success(lastRes && lastRes.msg)
        this.dialogVisible = false
      }
      if (successCount) this.$emit('saved')
    },
    shelfUpdate() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        this.$api.warehouseApi.shelfUpdate(this.buildPayload()).then((res) => {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('saved')
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 0 15px;

  /deep/.el-textarea__inner {
    height: 120px;
  }

  .el-select {
    width: 100%;
  }
}

.floor-grids {
  margin: -6px 0 12px 120px;
}

.floor-grid-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  .floor-label {
    width: 48px;
    text-align: right;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .el-input {
    width: 160px;
  }
}
</style>
